<template>
  <div class="vr">
    <div class="header">
      <div class="nav">
        <div class="left">
          <div @click="$router.go(-1)" class="back-icon"><i class="el-icon-back"></i></div>
          <div class="title">VR 更新</div>
        </div>
        <div class="right">
        </div>
      </div>
      <div class="option">
        <div class="left">
          <el-select size="medium"
                     style="width:260px"
                     v-model="floorId"
                     @change="changeFloor">
            <el-option
              v-for="item in place.floors"
              :key="item.id"
              :label="place.name + '/' + item.floor"
              :value="item.id">
            </el-option>
          </el-select>
          <el-input style="width:260px;margin-left:16px"
                    v-model.number="pid"
                    @change="changPanId"
                    @keyup.enter.native="changPanId"
                    placeholder="输入全景点位 ID"
                    size="medium" />
          <div style="margin-left:8px"
               class="btn-primary"
               type="primary"
               @click="changPanId">跳转</div>
        </div>
        <div class="right">
          <div @click="updateData"
               v-if="!upgrade"
               class="btn-plan"
               style="margin-right:12px;padding:8px 8px"><img style="width: 16px;margin-top:-4px" src="./assets/update1.png" ><span>数据包升级</span></div>
          <div v-else class="btn-upgrade" style="margin-right:12px"><img style="width: 16px;margin-top:-4px" src="./assets/update2.png" ><span>升级中</span></div>
          <div class="btn-primary" type="primary" @click="save">保存</div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="content">
        <div class="types">
          <div class="item">
            <div class="circle c1"></div>
            <div class="text">正常</div>
          </div>
          <div class="item">
            <div class="circle c2"></div>
            <div class="text">待更新</div>
          </div>
          <div class="item">
            <div class="circle c3"></div>
            <div class="text">更新中</div>
          </div>
          <div class="item">
            <div class="circle c4"></div>
            <div class="text">更新失败</div>
          </div>
        </div>
        <div v-if="panoModel" class="panoModel">
          <div class="info">全景点 ID {{panoData.pano_id}}
            <!-- <span v-if="panoData.state === 'normal'" class="tag normal">正常</span> -->
            <span v-if="panoData.state === 'going'" class="tag going">更新中</span>
            <span v-if="panoData.state === 'padding'" class="tag padding">待更新</span>
            <span v-if="panoData.state === 'fail'" class="tag fail">更新失败</span>
          </div>
          <div>
            <div class="btn-primary option-button"
                 v-if="panoData.state === 'normal'"
                 size="medium"
                 @click="updatePanState('padding')"
                 type="primary">标记更新</div>
            <div class="btn-plan option-button"
                 @click="updatePanState('normal')"
                 v-if="panoData.state === 'padding' || panoData.state === 'fail'"
                 size="medium">取消标记</div>
          </div>
        </div>
        <div class="containers">
          <div v-show="viewType === 1 || viewType === 0"
               class="container konva-container"
               :style="{
                 width: viewType === 0 ? '50%' : '100%'
               }">
            <img v-if="viewType === 0"
                 @click="changeViewType(1)"
                 class="zoom-btn"
                 src="./assets/in.png"
                 alt="">
            <img v-if="viewType === 1"
                 @click="changeViewType(0)"
                 class="zoom-btn"
                 src="./assets/out.png"
                 alt="">
            <div class="c" ref="container"></div>
          </div>
          <div v-show="viewType === 2 || viewType === 0"
               class="container owlly-container"
               :style="{
                 width: viewType === 0 ? '50%' : '100%'
               }">
            <img v-if="viewType === 0"
                 @click="changeViewType(2)"
                 class="zoom-btn"
                 src="./assets/in.png"
                 alt="">
            <img v-if="viewType === 2"
                 @click="changeViewType(0)"
                 class="zoom-btn"
                 src="./assets/out.png"
                 alt="">
            <div class="c" ref="owllyContainer"></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="数据包升级"
      :visible.sync="dialogVisible"
      :close-on-click-modal='false'
      :close-on-press-escape='false'
      width="30%">
      <p style="color:#303133">确定升级该区域的数据包？</p>
      <p><span style="color:#FF4D4F">升级需要大约 5-10 小时</span>，如果确定更新该区域，请先升级数据包。</p>
      <span slot="footer" class="dialog-footer">
        <div class="btn-plan" style="margin-right:12px" @click="dialogVisible=false">取消</div>
        <div class="btn-primary" type="primary" @click="toUpdateData">确定</div>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _, { floor, upperCase } from 'lodash';
import axios from 'axios';
import { vec4, mat4 } from 'gl-matrix';
import { SvgUtils, THREE, Shape, ShapeUtils } from '@aibee/owlly';
import { Loading } from 'element-ui';
import { uuid2 as uuid, formatDate } from '@/utils';
import request from '@/utils/request';
import Util from '../roadMapComponent/util';

import { Stage as KonvaStage, VIEW } from './core/stage';
import convertData from '@/components/mapComponents/convertData';
import { queryAllPois } from '@/api/map';
import Graphic from '../roadMapComponent/graphic';
import OwllyStage from '../roadMapComponent/owllyStage';
import Point from '../roadMapComponent/point';

const URL_ROOT = 'https://vr.aibee.cn';
const SECRET = 'secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so';

function getPositionTransform(
  [x, y],
  m,
) {
  const alignMat = mat4.fromValues(
    m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11], m[12], m[13], m[14], m[15],
  );
  const v = vec4.create();
  vec4.set(v, x, y, 0, 1);
  const result = vec4.create();
  vec4.transformMat4(result, v, alignMat);
  return { x: result[0], y: result[1] };
}
function generateStepsFromPath(path) {
  const commands = path.match(/([MLCmlc](?:(?:-?\d+(?:\.\d+)?(?:[eE]\d+)?)(?:,-?\d+(?:\.\d+)?(?:[eE]\d+)?)+))/g);
  if (!commands) { return []; }
  return commands.map((command) => {
    const c = command[0].toLowerCase();
    const coordStrings = command.slice(1).split(',');
    const coordCount = coordStrings.length;
    const coords = [];
    for (let i = 0; i < coordCount; i += 2) {
      coords.push([
        parseFloat(coordStrings[i]),
        parseFloat(coordStrings[i + 1]),
      ]);
    }
    return { command: c, coords };
  });
}

function generatePathFromSteps(steps) {
  return steps.map((_a) => {
    const command = _a.command; const
      coords = _a.coords;
    return (`${command}${coords.flat(2).join(',')}`);
  }).join('');
}
function generateGroupFromPath(path, trans) {
  const steps = generateStepsFromPath(path);
  const i = 0;
  const ss = steps.map((step) => {
    const crds = step.coords.map((v) => {
      const c = getPositionTransform(v, trans);
      return [c.x, c.y];
    });
    step.coords = crds;
    step.command = upperCase(step.command);
    return step;
  });
  // while (i < steps.length) {
  //   const step = steps[i];

  // const innerL = inner.length;
  // if (i === 0) {
  //   outer.push(step);
  // } else if (i > 0 && step.command !== 'm' && innerL === 0) {
  //   outer.push(step);
  // } else if (i > 0 && step.command === 'm') {
  //   // innerL++;
  //   inner[innerL] = [];
  //   inner[innerL].push(step);
  // } else if (i > 0 && innerL > 0 && step.command !== 'm') {
  //   // console.log('inner', inner, innerL)
  //   inner[innerL - 1].push(step);
  // }
  //   i++;
  // }
  return ss;
}

function distance(p1, p2) {
  const lx = (p1.x - p2.x) ** 2;
  const ly = (p1.y - p2.y) ** 2;
  return lx + ly;
}


export default {
  computed: {
    // floorId() {
    //   return parseInt(this.$route.query.floor_id, 10);
    // },
    placeId() {
      return this.$route.query.place_id;
    },
  },
  watch: {
  },
  data() {
    return {
      point: {},
      view: 1,
      viewType: 1,
      isPoi: false,
      target: null,
      jsonViewerVisible: false,
      importDataViewerVisible: false,
      targetType: null,
      place: {},
      importLabelingData: {},
      labelingResults: {},
      isVR: false,
      v_blockmark: '',
      v_new_roadnetwork: '',
      shapes: null,
      poiData: {
        pois: [],
        curPoiIndex: -1,
      },
      areaVisible: true,
      pointClickTimer: 0,
      dragDelay: 200,
      floorId: null,
      pid: null,
      panoModel: false,
      panoData: {},
      upgrade: false, // 数据升级
      dialogVisible: false,
    };
  },
  methods: {
    ...mapActions(['getFloorInfoInit']),
    async init() {
      const res = await this.getFloorInfoInit({ place_id: this.placeId });
      const place = res.find(i => i.id === parseInt(this.placeId, 10));
      // eslint-disable-next-line no-shadow
      const floor = place.floors.find(i => i.id === parseInt(this.floorId, 10));
      this.place = place;
      this.floor = floor;
      this.cmapAlignParam = null;
      this.cmapAlignParam = JSON.parse(floor.floor_cmap_align_param);
      this.isVR = !!this.floor.vr_id;

      if (this.isVR) {
        this.radius = SvgUtils.getRotateRadiusToNorth(this.cmapAlignParam.transformMatrices.upTrans);
      }
      this.northDegrees = this.radius * (180 / Math.PI);
      this.dataState();
      await this.initPanoData();
      this.initKonvaStage();
      this.initOwllyStage();
    },
    render3DPath(hideDatas = []) {
      if (!this.currentPano) return;
      const { point_dict, graphic_list } = this.konvaStage.exportData();
      const lines = graphic_list.filter(d => d.graphic_type === 'line');
      const hideLines = hideDatas.filter(d => d.graphic_type === 'line');

      this.owllyStage.clearPaths();
      lines.forEach((l) => {
        if (hideLines.find(hideLine => hideLine.graphic_id === l.graphic_id)) return;
        const from = point_dict[l.graphic_data[0]];
        const to = point_dict[l.graphic_data[1]];
        if (distance(from, this.currentPano) > 100000 && distance(to, this.currentPano) > 100000) return;
        const f = getPositionTransform([from.x, from.y], this.cmapAlignParam.transformMatrices.upTrans);
        const t = getPositionTransform([to.x, to.y], this.cmapAlignParam.transformMatrices.upTrans);
        this.owllyStage.addPath([
          [f.x, f.y, -1.2],
          [t.x, t.y, -1.2],
        ]);
      });
    },
    renderDragging3DPath(graphics) {
      if (!this.currentPano) return;
      const data = graphics;
      const { point_dict, graphic_list } = data;
      const lines = graphic_list.filter(d => d.graphic_type === 'line');

      this.owllyStage.clearDraggingPaths();
      lines.forEach((l) => {
        const from = point_dict[l.graphic_data[0]];
        const to = point_dict[l.graphic_data[1]];
        if (distance(from, this.currentPano) > 100000 && distance(to, this.currentPano) > 100000) return;
        const f = getPositionTransform([from.x, from.y], this.cmapAlignParam.transformMatrices.upTrans);
        const t = getPositionTransform([to.x, to.y], this.cmapAlignParam.transformMatrices.upTrans);
        this.owllyStage.addDraggingPaths([
          [f.x, f.y, -1.2],
          [t.x, t.y, -1.2],
        ]);
      });
    },
    async initOwllyStage() {
      if (!this.floor.vr_id) return;
      this.owllyStage = new OwllyStage({
        container: this.$refs.owllyContainer,
        vrId: this.floor.vr_id,
        panoramaList: this.panoramaList,
        modelPath: this.modelPath,
        initialView: this.initialView,
        listeners: {
          onMoveToPanorama: (pid) => {
            this.konvaStage.updateUserState(false);
            if (this.viewType !== 1) {
              this.konvaStage.updateUserPoint(pid);
              const data = this.labelingResults.graphic_list.find(e => pid === e.property.pano_id);
              this.panoClick(data);
            }
            this.render3DPath();
          },
          onPanoramaCameraChanged: (p) => {
            // const euler = new THREE.Euler();
            // euler.setFromQuaternion(p, 'ZYX');
            // const radians = euler.z > 0 ?
            //   euler.z :
            //   (2 * Math.PI) + euler.z;
            // const deg = THREE.Math.radToDeg(radians);
            // this.konvaStage.updateUserPoint({
            //   rotation: this.northDegrees - deg,
            // });
          },
        },
      });

      await this.owllyStage.init();
    },
    async initKonvaStage() {
      console.log('initKonvaStageinitKonvaStage');
      const { floor } = this;
      const params = JSON.parse(floor.floor_cmap_align_param);
      const position = new THREE.Vector3();
      const scale = new THREE.Vector3();
      const quaternion = new THREE.Quaternion();
      let panoramaWidth = 0;
      if (this.isVR) {
        new THREE.Matrix4().fromArray(params.transformMatrices.upTrans).decompose(position, quaternion, scale);
        const nscale = scale.x;
        panoramaWidth = 4 / nscale;
      }

      this.konvaStage = new KonvaStage({
        container: this.$refs.container,
        svgPath: floor.floor_cmap,
        svgAlignParam: JSON.parse(floor.floor_cmap_align_param),
        listeners: {
          errorHandler: (err) => {
            this.$message({
              type: 'error',
              message: err,
            });
          },
          pointDragStart: (e, type, changeDatas) => {
            this.target = e;
            this.targetType = type;
            this.render3DPath(changeDatas.graphic_list);
          },
          stageClick: () => {
            this.panoModel = false;
          },
          pointClick: (e, type, point) => {
            const now = Date.now();
            if ((now - this.pointClickTimer) > this.dragDelay) {
              this.pointClickTimer = now;
              if (point) {
                const f = getPositionTransform([point.x, point.y], this.cmapAlignParam.transformMatrices.upTrans);
                this.point = f;
              }
              this.target = e;
              this.targetType = type;
            }
            if (type === 'graphic' && e.property.type === '91') {
              this.owllyStage.moveToPanorama(e.property.pano_id);
              this.panoClick(e);
            }
          },
          blockClick: (e, type) => {
            this.target = e;
            this.targetType = type;
            this.point = {};
          },
          graphicChanged: (g) => {
            const { graphic_list } = g;
            if (Array.isArray(graphic_list)) {
              this.renderDragging3DPath(g);
            }
          },
          changeView: (view) => {
            if (view === 'selection') {
              this.view = 1;
            }
          },
        },
      });

      await this.initLabelResults();
      this.initPois();
      this.konvaStage.changeView(VIEW.SELECTION);
    },
    async initLabelResults() {
      let labelingResults = {
        graphic_list: [],
        point_dict: {},
        image_url: '',
        poiData: {
          pois: [],
          curPoiIndex: -1,
        },
      };
      labelingResults = this.addPanoData(labelingResults, this.panoramaList);
      this.labelingResults = labelingResults;

      const loading = Loading.service({
        fullscreen: true,
        text: '加载中...',
      });
      console.time('路网加载时间');
      this.konvaStage.loadGraphics(labelingResults);
      loading.close();
      console.timeEnd('路网加载时间');
    },
    // 点位点击
    panoClick(data) {
      this.panoData = data.property;
      this.panoModel = true;
    },
    // 输入点位切换
    changPanId() {
      if (!this.pid) return;
      this.konvaStage.updateUserState(true);
      this.konvaStage.updateUserPoint(this.pid);
      const data = this.labelingResults.graphic_list.find(e => this.pid === e.property.pano_id);
      this.panoClick(data);
      this.owllyStage.moveToPanorama(this.pid);
      this.render3DPath();
    },
    // 更新全景点状态
    updatePanState(state) {
      this.konvaStage.updatePanState(this.panoData.pano_id, state);
      this.panoData.state = state;
    },
    initPois() {
      if (this.labelingResults.poiData && this.labelingResults.poiData.curPoiIndex > -1) {
        this.poiData = _.cloneDeep(this.labelingResults.poiData);
        if (!this.poiData.curPoiIndex) {
          this.poiData.curPoiIndex = this.poiData.pois.length - 1;
        }
        if (this.poiData.curPoiIndex > -1) {
          this.konvaStage.loadPois(_.cloneDeep(this.poiData.pois[this.poiData.curPoiIndex].data));
        }
      }
    },
    // 获取全景点位
    async initPanoData() {
      if (!this.isVR) return;
      const {
        data: {
          data: {
            modelPath,
            status,
            panorama_list: panoramaList,
            initial_view: initialView,
          },
        },
      } = await axios({
        url: `/robot/v1/renewal/list-panoramas?${SECRET}`,
        method: 'POST',
        data: {
          store_id: this.floor.vr_id,
        },
      });

      const trans = this.cmapAlignParam.transformMatrices.downTrans;
      for (let i = panoramaList.length - 1; i >= 0; i--) {
        const neighbourPanoramaIDs = panoramaList[i].visible_panorama_seq_ids.map((value) => {
          let id = null;
          const item = panoramaList.find((it) => {
            if (it.seq_id && it.seq_id === value) {
              return it;
            }
          });
          id = item && item.id;
          return id;
        });
        panoramaList[i].neighbourPanoramaIDs = neighbourPanoramaIDs;
        const { x, y } = getPositionTransform([panoramaList[i].coordinate.position_x, panoramaList[i].coordinate.position_y], trans);
        panoramaList[i].x = x;
        panoramaList[i].y = y;
      }
      this.panoramaList = [];
      const fileterList = panoramaList.filter(e => e.visible);
      this.panoramaList = fileterList;
      this.panorama_status_list = status || {};
      this.modelPath = modelPath;
      this.initialView = initialView;
    },
    changeViewType(type) {
      setTimeout(() => {
        this.owllyStage.resize();
        this.konvaStage.resize();
      }, 0);
      this.konvaStage.setViewType(type);
      this.viewType = type;
    },
    addPanoData(labelResults, panoramaList) {
      if (!this.isVR) return labelResults;
      const trans = this.cmapAlignParam.transformMatrices.downTrans;
      panoramaList.forEach((p) => {
        if (!p.visible) return;
        const g = labelResults.graphic_list.find(l => l.graphic_type === 'point' && l.property.type === '91' && l.property.pano_id === p.id);
        if (!g) {
          const point = new Point(null, p.x, p.y);
          labelResults.point_dict[point.uuid] = point;
          labelResults.graphic_list.unshift({
            graphic_id: point.uuid,
            graphic_type: 'point',
            graphic_data: [point.uuid],
            property: {
              type: '91',
              seq_id: p.seq_id,
              pano_id: p.id,
              state: 'normal',
            },
            group_id: point.uuid,
            group_type: 'PanoramaPoint',
          });
        }
      });
      if (this.panorama_status_list.fail && this.panorama_status_list.fail.length > 0) {
        labelResults.graphic_list.forEach((e) => {
          this.panorama_status_list.fail.forEach((i) => {
            if (i === e.property.pano_id) {
              e.property.state = 'fail';
              e.property.state_original = 'fail';
            }
          });
        });
      }
      if (this.panorama_status_list.going && this.panorama_status_list.going.length > 0) {
        labelResults.graphic_list.forEach((e) => {
          this.panorama_status_list.going.forEach((i) => {
            if (i === e.property.pano_id) {
              e.property.state = 'going';
              e.property.state_original = 'going';
            }
          });
        });
      }
      if (this.panorama_status_list.padding && this.panorama_status_list.padding.length > 0) {
        labelResults.graphic_list.forEach((e) => {
          this.panorama_status_list.padding.forEach((i) => {
            if (i === e.property.pano_id) {
              e.property.state = 'padding';
              e.property.state_original = 'padding';
            }
          });
        });
      }
      // labelResults.graphic_list[10].property.state = 'going';
      // labelResults.graphic_list[20].property.state = 'padding';
      const res = [];
      labelResults.graphic_list.forEach((q) => {
        if (res.find(s => s.graphic_id === q.graphic_id && s.graphic_type === q.graphic_type)) {
          return;
        }
        res.push(q);
      });
      labelResults.graphic_list = res;

      return labelResults;
    },
    // 数据包状态查询
    async dataState() {
      const { data } = await axios({
        url: `/robot/v1/renewal/offline_packge/${this.floor.vr_id}`,
        method: 'get',
      });
      let hashData = false; // 未生成数据包
      // eslint-disable-next-line eqeqeq
      if (data.msg == '0') {
        this.dialogVisible = true;
      // eslint-disable-next-line eqeqeq
      } else if (data.msg == '1') {
        this.upgrade = false;
        hashData = true;
      } else { // 2
        this.upgrade = true;
        hashData = true;
      }
      return hashData;
    },
    // 升级
    updateData() {
      this.dialogVisible = true;
    },
    async toUpdateData() {
      const { data } = await axios({
        url: '/robot/v1/renewal/offline_packge',
        method: 'post',
        data: {
          store_id: this.floor.vr_id,
        },
      });
      if (data) {
        this.$notify({
          type: 'success',
          message: '启动更新成功',
        });
      }
      await this.dataState();
      this.dialogVisible = false;
    },
    // 楼层切换
    changeFloor() {
      const query = {
        ...this.$route.query,
      };
      query.floor_id = this.floorId;
      query.vr_id = this.floor.vr_id;
      this.$router.replace({
        path: '/map/vrUpdate',
        query,
      });
      // this.$router.go(0);
      if (this.konvaStage) {
        this.konvaStage.dispose();
        this.konvaStage = null;
      }
      if (this.owllyStage) {
        this.owllyStage.dispose();
        this.owllyStage = null;
      }
      // this.floorId = parseInt(this.$route.query.floor_id, 10);
      this.init();
      // window.location.reload();
    },
    // 保存
    async save() {
      // console.log(this.konvaStage.exportData().graphic_list);
      if (!await this.dataState()) return;
      const padding_graphic = this.konvaStage.exportData().graphic_list.filter(e => e.property.state === 'padding');
      const padding = padding_graphic.map(e => e.property.pano_id);
      const normal_graphic = this.konvaStage.exportData().graphic_list.filter(e => (e.property.state_original === 'fail' || e.property.state_original === 'padding') && e.property.state === 'normal');
      const normal = normal_graphic.map(e => e.property.pano_id);
      this.$confirm('是否保存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { data } = await axios({
          url: '/robot/v1/renewal/new_point',
          method: 'post',
          data: {
            place_id: this.placeId,
            floor_id: this.floor.id,
            padding,
            normal,
            store_id: this.floor.vr_id,
          },
        });
        console.log(data);
        this.changeFloor();
        this.$notify({
          type: 'success',
          message: '保存成功',
        });
      });
    },
    resizeHandler() {
      this.konvaStage.resize();
    },
  },
  created() {
    this.floorId = parseInt(this.$route.query.floor_id, 10);
  },
  mounted() {
    this.init();
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy() {
    if (this.konvaStage) {
      this.konvaStage.dispose();
    }
    if (this.owllyStage) {
      this.owllyStage.dispose();
    }

    window.removeEventListener('resize', this.resizeHandler);
  },
};
</script>

<style lang="scss" scoped>
.vr {
  /deep/ .el-input--medium .el-input__inner {
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    font-size: 14px;
  }
  width: 100%;
  @mixin flex{
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
  }
  @mixin flexitem{
    display: flex;
    align-items: center;
   }
  .header{
    width: 100%;
    .back-icon {
      padding-right: 32px;
      height: 100%;
      font-size: 20px;
      color: #303133;
      font-weight: 500;
      display: flex;
      align-items: center;
      border-right: 1px solid #E7EAED;
    }
    .title {
      padding-left: 32px;
      font-size: 20px;
      font-weight: 500;
      color: #303133;
    }
    .nav {
      width: 100%;
      height: 50px;
      box-shadow: 0px 2px 4px 0px rgba(201,208,216,0.19);
      @include flex
    }
   .option {
     width: 100%;
     height: 64px;
     @include flex
   }
   .left {
     @include flexitem
   }
   .right{
     @include flexitem
   }
  }
  .body{
    position: relative;
    height: calc(100vh - 50px - 64px);
    padding: 16px;
    background: #F2F4F7;
    .content {
      width: 100%;
      height: 100%;
      background: #FFFFFF;
      border-radius: 8px;
      position: relative;
      overflow: hidden;
      .types {
        z-index: 1;
        top: 16px;
        left: 16px;
        position: absolute;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 360px;
        padding: 16px 16px;
        background: #FFFFFF;
        box-shadow: 0 0 6px 1px rgba(132, 136, 140, 0.13);
        border-radius: 6px;
        color: #303133;
        .item {
          display: flex;
        }
        .circle {
          margin-right: 12px;
          width: 14px;
          height: 14px;
          border-radius: 50%;
        }
        .text {
          font-size: 14px;
          line-height: 14px;
        }
        .c1 {
          background: rgba(103, 194, 58, 0.4);
        }
        .c2 {
          background: rgba(255, 169, 32, 0.4);
        }
        .c3 {
           background: rgba(10, 124, 255, 0.4);
        }
        .c4 {
          background: rgba(255, 77, 79, 0.4);
        }
      }
      .panoModel {
        z-index: 2;
        top: 80px;
        left: 16px;
        position: absolute;
        background: #FFFFFF;
        padding: 16px 16px;
        box-shadow: 0px 6px 16px 0px rgba(17,19,20,0.06), 0px 3px 6px -4px rgba(17,19,20,0.12);
        border-radius: 4px;
        .info {
          font-weight: 600;
          color: #303133;
          font-size: 14px;
          display: flex;
          align-items: center;
          .tag {
            margin-left: 10px;
            padding: 4px;
            font-size: 10px;
            line-height: 10px;
            font-weight: 400;
            color: #FFFFFF;
            border-radius: 2px;
          }
          .going {
            background: #0A7CFF;
          }
          .padding {
            background: #FFA920;
          }
          .fail {
            background: #FF4D4F;
          }
        }
        .option-button {
          margin-top: 21px;
          width: 100%;
        }
      }
      .containers {
        position: relative;
        height: calc(100% - 40px);
        display: block;
        width: 100%;
        .container {
          display: block;
          float: left;
          position: relative;
          flex: 0 0 50%;
          height: 100%;
          background: white;
          .zoom-btn {
            position: absolute;
            right: 10px;
            top: 10px;
            cursor: pointer;
            z-index: 1000;
            width: 54px;
            height: 54px;
          }
          .c {
            position: relative;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .btn-primary {
    cursor: pointer;
    user-select: none;
    padding: 8px 24px;
    height: 32px;
    box-sizing: border-box;
    background: #0A7CFF;
    border-radius: 4px;
    border: 1px solid #0A7CFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #FFFFFF;
  }
  .btn-plan{
    cursor: pointer;
    user-select: none;
    padding: 8px 24px;
    height: 32px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #D4D8DD;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #303133;
  }
  .btn-upgrade{
    cursor: pointer;
    user-select: none;
    padding: 8px 24px;
    height: 32px;
    box-sizing: border-box;
    background: #FFF7EB;
    border-radius: 4px;
    border: 1px solid #FCCB7C;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #FCCB7C;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
